import React from 'react'
import toggle from 'components/common/hoc/toggle'
import YMME from './ShopByVehicle'
import Plate from './ShopByPlate'
import TireSizesNotFoundModal from './TireSizesNotFoundModal'

/* eslint-disable react/prop-types */
const YMMEPlateWrapper = ({ expanded, toggleHandlers, ...props }) =>
  <React.Fragment>
    {
      expanded ?
        <Plate { ...props } toggle={ toggleHandlers.onClick } /> :
        <YMME { ...props } toggle={ toggleHandlers.onClick } />
    }
    <TireSizesNotFoundModal />
  </React.Fragment>


export default toggle(YMMEPlateWrapper)
